import React from 'react';
import PropTypes from 'prop-types';

import Status from './Status';
import { ModalBody } from '@eventbrite/eds-modal';
import LanguageAndBrand from '../../components/languageAndBrand';

import { ABANDON_ORDER_STATUSES } from './constants';
import { BACK_TO_SERIES_EVENTS_TITLE } from '../../constants';

import { resetFocusToInitialElement } from '../../utils/accessibility';
import { FOCUSABLE_ELEMENTS } from '../../constants/focusableElements';

import { ArrowLeftChunky } from '@eventbrite/eds-iconography';

import defaultStyles from './StatusPage.module.scss';
import rebrandStyles from './StatusPage.rebranding.module.scss';
import classNames from 'classnames';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../utils/rebrand';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export default class StatusPage extends React.PureComponent {
    static propTypes = {
        isSeriesInfiniteCalendar: PropTypes.bool,
        statusType: PropTypes.string.isRequired,
        toCheckout: PropTypes.func.isRequired,
        toInterstitial: PropTypes.func.isRequired,
        toLogin: PropTypes.func.isRequired,
        toInterstitial: PropTypes.func.isRequired,
        toTicketSelection: PropTypes.func.isRequired,
        toDeliveryMethod: PropTypes.func,
        toPickASeat: PropTypes.func,
        toReservedTicketConfirmation: PropTypes.func,
        closeModal: PropTypes.func,
        toTicketSelectionFromInterstitial: PropTypes.func,
        shouldShowBackToSeriesLink: PropTypes.bool,
        onBackToSeries: PropTypes.func,
        shouldNavigateToTicketSelectionWhenClosingModal: PropTypes.bool,
    };

    _getHeaderProps(isSeriesInfiniteCalendar) {
        const {
            eventTitle,
            eventDate,
            onBackToSeries,
            shouldShowBackToSeriesLink,
        } = this.props;
        let headerProps;

        // For repeating event, can go back to the parent series page.
        if (shouldShowBackToSeriesLink && !isSeriesInfiniteCalendar) {
            headerProps = {
                title: eventTitle,
                secondaryTitle: eventDate,
                headerActionIconType: <ArrowLeftChunky />,
                headerActionTitle: BACK_TO_SERIES_EVENTS_TITLE,
                onHeaderAction: onBackToSeries,
            };
        }

        return headerProps;
    }

    focusRef = React.createRef();

    componentDidMount() {
        resetFocusToInitialElement({
            rootEl: this.focusRef.current,
            focusableEls: FOCUSABLE_ELEMENTS,
        });
    }

    render() {
        const {
            closeModalActions,
            closeModalOnNativeActions,
            eventSalesStatus,
            featureFlags,
            isSeriesInfiniteCalendar,
            isAppRebrandActive,
            isNativeApp,
            shouldNavigateToTicketSelectionWhenClosingModal,
            statusType,
            toCheckout,
            toDeliveryMethod,
            toLogin,
            toInterstitial,
            toPickASeat,
            toReservedTicketConfirmation,
            toTicketSelection,
            toTicketSelectionFromInterstitial,
        } = this.props;
        const theme = getStyles(isAppRebrandActive);
        const styles = stylesModules[theme];

        let languageAndBrand = null;

        // Language Selector should only be shown on non-Abandon status pages
        // because it currently triggers a reload
        if (!ABANDON_ORDER_STATUSES.includes(statusType)) {
            languageAndBrand = (
                <LanguageAndBrand
                    shouldShowLanguageLabel={!isSeriesInfiniteCalendar}
                    isVertical={true}
                />
            );
        }

        const rootClassName = classNames(
            'g-vert-full-height eds-text--center',
            styles?.root,
        );

        const statusWrapperClassName = classNames('eds-align--center', {
            'eds-l-pad-hor-5': isAppRebrandActive,
            'eds-l-pad-all-4': !isSeriesInfiniteCalendar,
            [styles?.seriesInfiniteCalendarViewStatusWrapper]:
                isSeriesInfiniteCalendar,
        });

        return (
            <ModalBody {...this._getHeaderProps(isSeriesInfiniteCalendar)}>
                <div className={rootClassName}>
                    <div className={statusWrapperClassName} ref={this.focusRef}>
                        <Status
                            closeModalActions={closeModalActions.bind(
                                null,
                                shouldNavigateToTicketSelectionWhenClosingModal,
                            )}
                            closeModalOnNativeActions={
                                closeModalOnNativeActions
                            }
                            eventSalesStatus={eventSalesStatus}
                            featureFlags={featureFlags}
                            isAppRebrandActive={isAppRebrandActive}
                            isNativeApp={isNativeApp}
                            statusType={statusType}
                            toCheckout={toCheckout}
                            toDeliveryMethod={toDeliveryMethod}
                            toLogin={toLogin}
                            toInterstitial={toInterstitial}
                            toPickASeat={toPickASeat}
                            toReservedTicketConfirmation={
                                toReservedTicketConfirmation
                            }
                            toTicketSelection={toTicketSelection}
                            toTicketSelectionFromInterstitial={
                                toTicketSelectionFromInterstitial
                            }
                        />
                    </div>
                    <div
                        className={classNames({
                            [styles?.seriesInfiniteCalendarLanguageAndBrandWrapper]:
                                isSeriesInfiniteCalendar,
                        })}
                    >
                        {languageAndBrand}
                    </div>
                </div>
            </ModalBody>
        );
    }
}
